<template>
  <!-- web端部分 -->
  <div
    class="web Home"
    v-if="$store.state.isMobile === 'web'"
  >
    <video
      id="startvideo"
      v-if="videoShow"
      autoplay
      loop
      muted
    >
      <source
        src="../assets/images/home/video.mp4"
        type="video/mp4"
      />
    </video>
    <div class="content">
      <transition
        enter-active-class="animate__animated animate__fadeInLeftBig"
        leave-active-class="animate__animated animate__fadeOut"
      >
        <div
          v-if="isBounceHome"
          class="left-box"
        >
          <img
            :src="require('../assets/images/home/Word.png' + imgSuffixWebp)"
            alt=""
          />
        </div>
      </transition>
      <transition
        enter-active-class="animate__animated animate__fadeInRightBig"
        leave-active-class="animate__animated animate__fadeOut"
      >
        <div
          v-if="isBounceHome"
          class="right-box"
        >
          <img
            :src="require('../assets/images/home/hand.png' + imgSuffixWebp)"
            alt=""
          />
        </div>
      </transition>
    </div>
    <div class="footer">
      <div class="animate__animated animate__fadeInUp">
        <Footer />
      </div>
    </div>
  </div>
  <!-- 手机端部分 -->
  <wapHome v-else></wapHome>
</template>

<script>
import wapHome from '../components/wapHome/index.vue';
import { imgSuffix } from '../utils/common';
import Footer from '@/components/footer.vue'
export default {
  name: 'Main',
  components: {
    wapHome,
    Footer
  },
  data() {
    return {
      isMobile: '',
      isBounceHome: false,
      videoShow: false,
      imgSuffixWebp: imgSuffix,
    };
  },
  methods: {},
  created() {
    this.videoShow = true;
  },
  mounted() {
    this.isBounceHome = true;
    if (this.$store.state.isMobile == 'web') {
      let video = document.getElementById('startvideo');
      video.play();
    } else {
      document.querySelector('body').setAttribute('style', 'overflow: initial;'); // 当wap详情页返回按钮时 恢复滚动
    }
  },
  destroyed() {
    this.isBounceHome = false;
    this.videoShow = false;
  },
};
</script>

<style lang="scss" scoped>
.web.Home {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: #000;
  // background-image: url('../assets/images/home/home-bg.gif');
  background-size: cover;
  background-repeat: no-repeat;

  #startvideo {
    position: fixed;
    top: 0;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  .content {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    .left-box {
      width: 30%;
      height: auto;
      margin-right: 90px;
      animation-duration: 0.6s;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right-box {
      animation-duration: 0.6s;
      img {
        display: block;
        width: 92%;
        height: auto;
      }
    }
  }
  .footer {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 39px;
    font-size: 14px;
    font-family: Verdana, Geneva, sans-serif;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
